import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { FlexBox, Avatar, P } from '@vp/swan';
import styles from './designer-attribution.module.scss.js';

const DesignerAttribution = forwardRef((props, ref) => {
  const { designerName, avatarURL, darkMode, textColor = "standard" } = props;
  return /* @__PURE__ */ jsxs(FlexBox, { ref, gap: 3, children: [
    /* @__PURE__ */ jsx(FlexBox, { alignItems: "center", children: /* @__PURE__ */ jsx(Avatar, { src: avatarURL, size: "mini", alt: `profile picture of designer ${designerName}`, className: styles.designerAttributionAvatar }) }),
    /* @__PURE__ */ jsx(FlexBox, { className: styles.designerAttributionTextContainer, darkMode, children: /* @__PURE__ */ jsx(P, { fontWeight: "bold", textColor, overflow: "hidden", margin: "0", className: styles.designerAttributionText, children: designerName }) })
  ] });
});

export { DesignerAttribution };
